import { notifications } from '@mantine/notifications'
import { useQueryClient } from '@tanstack/react-query'

import type { EditGoalProps } from '@/modules/actionPlan/pages/components/EditGoal/EditGoal.types'
import { GoalForm } from '@/modules/actionPlan/pages/components/GoalForm/GoalForm'
import type { GoalFormSchema } from '@/modules/actionPlan/pages/components/GoalForm/GoalForm.types'
import { goalFormDefaultValues } from '@/modules/actionPlan/pages/components/GoalForm/GoalForm.values'

import {
  useGoalsServiceGoalsControllerGetAllKey,
  useGoalsServiceGoalsControllerUpdate,
} from '@/__generated__/queries'

import { INSIGHTS_QUERY_KEY } from '@/hooks/useInsightsQuery.hook'

export function EditGoal({ goal, onClose }: EditGoalProps) {
  const INVALIDATE_KEYS = [
    useGoalsServiceGoalsControllerGetAllKey,
    INSIGHTS_QUERY_KEY,
  ]

  const queryClient = useQueryClient()

  const updateGoalMutation = useGoalsServiceGoalsControllerUpdate({
    onSuccess: () => {
      notifications.show({
        color: 'green',
        message: 'Goal updated successfully',
        title: 'Goal updated',
      })

      INVALIDATE_KEYS.forEach(key => {
        queryClient.invalidateQueries({
          queryKey: [key],
        })
      })

      onClose()
    },
  })

  const handleSubmit = (values: GoalFormSchema) => {
    updateGoalMutation.mutate({
      goalId: goal?.id ?? 0,
      requestBody: values,
    })
  }

  const initialValues = goalFormDefaultValues(goal)

  return (
    <GoalForm
      data={initialValues}
      edit
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}
